import { EOtpremnicaPrevozView } from "../eotpremnica/eotpremnica-prevoz-view";

export class EPrijemnicaPrevozView extends EOtpremnicaPrevozView{
    constructor(){
        super();
    }

    Deserialize(input:any){
        super.Deserialize(input);
        return this;
    }

    Serialize(input:EPrijemnicaPrevozView){
        return input;
    }
}